import { Component, OnInit, ViewChild } from '@angular/core';
import { PopupModel, PopupButton, PopupModelReturn, SP_Type, SPType_ServiceProvider, ServiceProvider, PopupSetupModel, Patient, Lookups, Staff, Branch, ReportHistory } from '../../AllTableClasses';
import { PopupNotificationService } from '../../Services/popup-notification.service';
import { Router } from '@angular/router';
import { NotificationPopupComponent } from '../Components/notification-popup/notification-popup.component';
import { ServiceProviderService } from '../../Services/service-provider.service';
import { MembersService } from '../../Services/members.service';
import { PatientSetupPopupComponent } from '../Components/patient-setup-popup/patient-setup-popup.component';
import { LookupsService } from '../../Services/lookups.service';
import { StaffService } from '../../Services/staff.service';
import { StaffSetupPopupComponent } from '../Components/staff-setup-popup/staff-setup-popup.component';
import { SchedulerService } from '../../Services/scheduler.service';
import UserSession from '../../Config/user-session';
import { LoadingService } from '../../Services/loading.service';
import { ReportsService } from '../../Services/reports.service';

@Component({
  selector: 'app-staff-main-page',
  templateUrl: './staff-main-page.component.html',
  styleUrl: './staff-main-page.component.scss'
})
export class StaffMainPageComponent {

  @ViewChild('popup') popup!: NotificationPopupComponent;
  @ViewChild('patientPopup') ServicePopup!: StaffSetupPopupComponent;

  public staffList: Array<Staff> = new Array<Staff>();
  public filteredItems: Array<Staff> = new Array<Staff>();
  public itemsPaged: Array<Staff> = new Array<Staff>();
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public pageIndex: number = 0;
  public lastPageIndex: number = 0;


  public selectedStaff: Staff = new Staff();

  public provinces: Array<Lookups> = new Array<Lookups>();
  public branches: Array<Branch> = new Array<Branch>();
  public selectedProvinceID!: number;
  public selectedBranchID!: number | null;
  public pageSize: number | null = 20;
  public filterString: string = "";
  public includeInactive: boolean = false;
  public reportParam!: string | undefined;
  constructor(
    private router: Router,
    private popupNotificationService: PopupNotificationService,
    private schedulerService: SchedulerService,
    private staffService: StaffService,
    private lookupService: LookupsService,
    private reportService: ReportsService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.pageSize = 20;
    this.selectedProvinceID = UserSession.ProvinceID;
    this.selectedBranchID = UserSession.BranchID;
    this.StaffSearch();
    this.ProvinceGet();
    this.UserBranchesGet();
  }
  
  public SelectStaff(staff: Staff) {
    if (!staff.Selected) {
      this.selectedStaff = new Staff();
    }
    else
    {
      if (this.selectedStaff && this.selectedStaff.Guid !== staff.Guid) {
        this.selectedStaff.Selected = false;
      }
      this.selectedStaff = staff;
    }
  }


  public StaffSearch() {
    this.selectedStaff = new Staff();

    this.staffService.StaffSearch(this.filterString, this.includeInactive, this.selectedProvinceID, this.selectedBranchID, this.pageSize, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
        this.filter();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ProvinceGet() {
    this.lookupService.ProvinceGet((data) => {
      if (data.Success) {
        this.provinces = data.Data;        
      }
      else
      {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public UserBranchesGet() {

    this.schedulerService.BranchGetByProvinceID(this.selectedProvinceID, (data) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });

    this.filter();
  }

  public BranchGetByProvinceID() {
    this.branches = [];
    this.selectedBranchID = null;
    if (this.selectedProvinceID == null) {
      this.selectedProvinceID = 0;
    }
    this.schedulerService.BranchGetByProvinceID(this.selectedProvinceID, (data) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);
      }
      else
      {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });

    this.filter();
  }

  //public filterByBranch() {
  //  this.StaffSearch();
  //  this.paginate();
  //}

  /* pagination */
  public filter() {
    if (this.filterString.trim() !== '') {
      this.filteredItems = this.staffList.filter(staffMember =>
        staffMember.Name.toLowerCase().includes(this.filterString.toLowerCase()) ||
        staffMember.IDNumber.toLowerCase().includes(this.filterString.toLowerCase()) ||
        staffMember.Surname.toLowerCase().includes(this.filterString.toLowerCase()) 
       
        //staffMember.Cellphone.toLowerCase().includes(this.filterString.toLowerCase())
      );
    }
    else {
      this.filteredItems = this.staffList;
    }
    this.paginate();
  }

  public paginate() {
    this.itemsPaged = this.filteredItems;
    //const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    //const endIndex = startIndex + this.itemsPerPage;
    //this.pageIndex = this.currentPage > 2 ? this.currentPage : 2;
    //this.lastPageIndex = Math.ceil(this.filteredItems.length / this.itemsPerPage);
    //this.itemsPaged = this.filteredItems.slice(startIndex, endIndex);
  }

  public updatePaginatedStaff(pageItems: Array<Staff>): void {
    this.itemsPaged = pageItems;
  }

  goToPage(pageNumber: number) {
    this.currentPage = pageNumber;
    this.paginate();
  }
  /* ----- */

  public View(staff: Staff) {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Staff Details';
    service_Popup.PopupAction = 'VIEW';
    service_Popup.Data = staff;
    service_Popup.Button = new PopupButton('Clear', 'Clear');
    service_Popup.AltButton = new PopupButton('Back', 'Cancel');

    this.popupNotificationService.ShowStaffSetupPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Clear')
      {
        let staff: Staff = new Staff();
        staff = res.Data;
        this.ClearStaffHistory(staff);
      }
      else {
      }
    });
  }

  public Add() {
    let staff: Staff = new Staff();
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'New Staff Member';
    service_Popup.PopupAction = 'NEW';
    service_Popup.Data = staff;
    service_Popup.Button = new PopupButton('Save', 'Save');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowStaffSetupPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.StaffSetByGuid(res.Data);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Edit(staff: Staff) {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Edit Staff Member Details';
    service_Popup.PopupAction = 'EDIT';
    service_Popup.Data = staff;
    service_Popup.Button = new PopupButton('Save', 'Save');

    this.popupNotificationService.ShowStaffSetupPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.StaffSetByGuid(res.Data);
      }
      else {
      }
    });
  }

  public Delete(staff: Staff) {
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = 'Are you sure you want to delete this Staff?';
    service_Popup.MessageType = 'error';
    service_Popup.Data = staff;
    service_Popup.Button = new PopupButton('Delete', 'Delete');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Delete') {
        staff.Active = false;
        this.StaffSetByGuid(staff);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Retry(staff: Staff) {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'New Staff Member';
    service_Popup.PopupAction = 'NEW';
    service_Popup.Data = staff;
    service_Popup.Button = new PopupButton('Save', 'Save');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowStaffSetupPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.StaffSetByGuid(res.Data);
      }
      else {
      }
    });
  }

  public ClearStaffHistory(staff: Staff) {
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = "Are you sure you want to clear this Staff's History?";
    service_Popup.MessageType = 'error';
    //service_Popup.Data = patient;
    service_Popup.Button = new PopupButton('Clear', 'ClearHistory');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');
    this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'ClearHistory') {
        this.ActivityHistorySetInactive(staff);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public ActivityHistorySetInactive(staff: Staff) {
    this.staffService.ActivityHistorySetInactive(staff, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { console.log(error); });
  }

  public StaffSetByGuid(staff: Staff) {


    this.staffService.StaffSetByGuid(staff, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);

      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage, staff);
      }
    }, (error) => { console.log(error); });
  }

  onGenerateReport(rendertype: string) {
    let report: ReportHistory = new ReportHistory();
    report.FileName = 'StaffReport';
    report.FilePath = 'StaffReport.rdl';

    const reportPath = report.FilePath;
    const reportName = report.FileName;

    const parameters = {
      BranchID: this.selectedBranchID || 0,
      ProvinceID: this.selectedProvinceID || 0,
      Gender: this.reportParam || '',
    }; // Add any required parameters here
    this.loadingService.show();

    this.reportService.GenerateReport(reportPath, reportName, parameters, rendertype, (data) => {
      this.loadingService.hide();
      if (data instanceof Blob) {
        if (rendertype == 'PDF') {
          const blob = new Blob([data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.xls`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        report.Action = 'Report Downloaded';
        //this.ReportActivityHistorySet(report);

      } else if (data.Success === false) {
        // If there's an error, display the error message
        this.loadingService.hide();
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public showNotifcationPopup(success: boolean, message?: string, staff?: Staff) {
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Message = 'Updated Successfully';
    notificationPopup.MessageType = 'success';
    //notificationPopup.Button = new PopupButton('Cancel', 'routeToStaff');
    notificationPopup.Button = new PopupButton('Calendar', 'routeToCalendar');

    if (success == true) {
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
        if (res.Result === 'routeToStaff') {
          this.router.navigate(['scheduler']);
          return;
        }
        else {
          this.StaffSearch();
        }
      });
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      notificationPopup.AltButton = new PopupButton('Retry', 'retry');
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
        if(res.Result === 'retry' && staff)
        {
          this.Retry(staff);
        }
      });
    }

  }
}
